/**
 * Stage 2 — Grasslands campaign (Campaign V3 / M95).
 * Long levels materialized via authoring helpers.
 */

import type { ChapterDefinition, StageDefinition } from '../combat/campaign/types'
import { withDistributedRoutesAll } from './distributeRoutes'
import { materializeAllChapter2Stages } from './authoring/materializeChapter2'

export const CHAPTER_2: ChapterDefinition = {
  id: 'chapter-2',
  campaignId: 'campaign-main',
  displayName: 'Stage 2 — Grasslands',
  chapterNumber: 2,
  biomeId: 'grasslands',
  enemyFamilyIds: ['troll'],
  stageIds: Array.from({ length: 30 }, (_, i) => `chapter2-stage${i + 1}`)
}

export const CHAPTER_2_STAGES: StageDefinition[] = withDistributedRoutesAll(
  materializeAllChapter2Stages()
)

/** @deprecated Prefer CHAPTER_2_STAGES from registry. */
export const STAGE_BY_ID_CHAPTER_2: Record<string, StageDefinition> = Object.fromEntries(
  CHAPTER_2_STAGES.map((s) => [s.id, s])
)
